import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  deleteUserNotification,
  getAllNotifications,
  getAllNotificationsCount,
  readAllNotifications,
  readNotification,
} from "../dispatcher/notificationDispatcher";

interface NotificationState {
  loading: boolean;
  notifications: any[];
  notification: any;
  notificationCount: number;
  loadingActionNotification: boolean;

  totalCount: number | null;
  totalPages: number | null;
  pageSize: number | null;
  page: number | null;
  sort: any;
  status: string;
}

const initialState: NotificationState = {
  loading: false,
  notifications: [],
  notification: null,
  notificationCount: 0,
  loadingActionNotification: false,

  totalCount: null,
  totalPages: null,
  pageSize: 10,
  page: 1,
  sort: {
    key: "createdAt",
    direction: "desc",
  },
  status: "all",
};

// Create a slice for actions and reducers
export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    receivedNotification: (state) => {
      state.notificationCount = state.notificationCount + 1;
    },
    updateSort: (state, action: PayloadAction<any>) => {
      state.sort = action.payload;
    },
    updateStatus: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
    },
    updatePage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    updatePageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllNotifications.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllNotifications.fulfilled, (state, action) => {
      state.loading = false;
      state.notifications = action.payload.data;
      state.totalCount = action.payload.pagination.totalCount;
      state.totalPages = Math.ceil(action.payload.pagination.totalCount / (state.pageSize || 10));
      state.page = action.payload.pagination.page;
    });
    builder.addCase(getAllNotifications.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllNotificationsCount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllNotificationsCount.fulfilled, (state, action) => {
      state.loading = false;
      state.notificationCount = action.payload.count;
    });
    builder.addCase(getAllNotificationsCount.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(readNotification.pending, (state) => {
      state.loadingActionNotification = true;
    });
    builder.addCase(readNotification.fulfilled, (state) => {
      state.loadingActionNotification = false;
    });
    builder.addCase(readNotification.rejected, (state) => {
      state.loadingActionNotification = false;
    });
    builder.addCase(readAllNotifications.pending, (state) => {
      state.loadingActionNotification = true;
    });
    builder.addCase(readAllNotifications.fulfilled, (state) => {
      state.loadingActionNotification = false;
    });
    builder.addCase(readAllNotifications.rejected, (state) => {
      state.loadingActionNotification = false;
    });
    builder.addCase(deleteUserNotification.pending, (state) => {
      state.loadingActionNotification = true;
    });
    builder.addCase(deleteUserNotification.fulfilled, (state) => {
      state.loadingActionNotification = false;
    });
    builder.addCase(deleteUserNotification.rejected, (state) => {
      state.loadingActionNotification = false;
    });
  },
});

// Export actions
export const {
  receivedNotification,
  updateSort,
  updateStatus,
  updatePage,
  updatePageSize,
} = notificationSlice.actions;

// Export reducer
export default notificationSlice.reducer;
